module.exports = __webpack_public_path__ + "img/Dantam Makeover 05.c14eb960.jpg";